import { FC } from 'react';

import Table from 'modules/_shared/Table';

import PartnerSharesTableHeader from './PartnerSharesTableHeader';
import PartnerSharesTableBody from './PartnerSharesTableBody';

type PartnerSharesTableProps = {
  compact?: boolean;
};

const PartnerSharesTable: FC<PartnerSharesTableProps> = ({ compact = false }) => {
  const tableContent = (
    <>
      <PartnerSharesTableHeader />
      <PartnerSharesTableBody />
    </>
  );

  return <Table content={tableContent} scrollHorizontal compact={compact} />;
};

export default PartnerSharesTable;
